import { UserCircleIcon, StarIcon } from "@heroicons/react/24/outline";
import {
  CONTACT_CATEGORY,
  getEligibleCategoriesFromSubRoles,
  isLastCategoryContact,
  MIN_CONTACT_ERROR,
} from "./requestContactDesignations";

/**
 * Build hamburger menu items for VQQ / Assessment contact designations.
 */
export function buildVendorContactMenuItems({
  allUsers = [],
  onToggleRequestContact,
  onMakePrimary,
  showItem = true,
}) {
  if (!showItem) return [];

  const buildCategoryItems = (category, sectionLabel, contactLabels, primaryLabels) => {
    const requestField =
      category === CONTACT_CATEGORY.RFI
        ? "rfi_request_contact_status"
        : "assessment_request_contact_status";
    const primaryField =
      category === CONTACT_CATEGORY.RFI ? "rfi_is_primary" : "assessment_is_primary";
    const iconActive = category === CONTACT_CATEGORY.RFI ? "text-indigo-500" : "text-amber-500";

    return [
      {
        type: "section",
        label: sectionLabel,
        showItem: (row) =>
          getEligibleCategoriesFromSubRoles(row.sub_roles).includes(category),
      },
      {
        label: contactLabels.make,
        icon: <UserCircleIcon className="h-5 w-5" />,
        onClick: (row) => onToggleRequestContact(row, category, true),
        showItem: (row) =>
          getEligibleCategoriesFromSubRoles(row.sub_roles).includes(category) &&
          !row[requestField],
      },
      {
        label: contactLabels.active,
        icon: <UserCircleIcon className={`h-5 w-5 ${iconActive} group-hover:text-gray-500`} />,
        onClick: (row) => {
          if (isLastCategoryContact(allUsers, row, category)) {
            window.alert(MIN_CONTACT_ERROR[category]);
            return;
          }
          onToggleRequestContact(row, category, false);
        },
        showItem: (row) =>
          getEligibleCategoriesFromSubRoles(row.sub_roles).includes(category) &&
          row[requestField] &&
          !row[primaryField],
      },
      {
        label: primaryLabels.make,
        icon: <StarIcon className="h-5 w-5" />,
        onClick: (row) => onMakePrimary(row, category),
        showItem: (row) =>
          getEligibleCategoriesFromSubRoles(row.sub_roles).includes(category) &&
          !row[primaryField],
      },
      {
        label: primaryLabels.active,
        icon: <StarIcon className="h-5 w-5 text-amber-500 group-hover:text-gray-500" />,
        onClick: () => {},
        showItem: (row) =>
          getEligibleCategoriesFromSubRoles(row.sub_roles).includes(category) &&
          row[primaryField],
      },
    ];
  };

  return [
    ...buildCategoryItems(
      CONTACT_CATEGORY.RFI,
      "VQQ Contact",
      { make: "Make VQQ Request Contact", active: "VQQ Request Contact" },
      { make: "Make VQQ Primary Contact", active: "VQQ Primary Contact" },
    ),
    ...buildCategoryItems(
      CONTACT_CATEGORY.ASSESSMENT,
      "Assessment Contact",
      { make: "Make Assessment Request Contact", active: "Assessment Request Contact" },
      { make: "Make Assessment Primary Contact", active: "Assessment Primary Contact" },
    ),
  ];
}
